import React from 'react';
import { ShieldCheckIcon, MicIcon, ListChecksIcon, AlertTriangleIcon, UsersIcon } from 'lucide-react';
import { ScreenProps } from '../../types/ptp';
import { PrimaryButton } from '../ui/PrimaryButton';
export function NewPTPScreen({
  data,
  onNext
}: ScreenProps) {
  return <div className="flex flex-col h-full justify-between pb-6 pt-10" data-id="element-309">
      <div className="flex flex-col items-center text-center space-y-6" data-id="element-310">
        <div className="w-24 h-24 bg-orange-500/10 rounded-full flex items-center justify-center border border-orange-500/20 mb-2" data-id="element-311">
          <ShieldCheckIcon className="w-12 h-12 text-orange-500" data-id="element-312" />
        </div>

        <div data-id="element-313">
          <h1 className="text-3xl font-bold text-white mb-3" data-id="element-314">
            New Pre-Task Plan
          </h1>
          <p className="text-slate-400 text-base max-w-[300px] mx-auto leading-relaxed" data-id="element-315">
            You'll describe the task by voice, then AI will help you build a
            complete safety plan step by step.
          </p>
        </div>

        <div className="w-full mt-4 bg-slate-900/50 border border-slate-800/50 rounded-xl p-5 text-left" data-id="element-316">
          <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-3" data-id="element-317">
            What to expect
          </p>
          <div className="space-y-3" data-id="element-318">
            {[{
            icon: MicIcon,
            text: 'Describe the task using your voice'
          }, {
            icon: ListChecksIcon,
            text: 'Review job steps and work environment'
          }, {
            icon: AlertTriangleIcon,
            text: 'Identify hazards and control measures'
          }, {
            icon: UsersIcon,
            text: 'Assign crew roles and safety checks'
          }].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-319">
                <div className="w-8 h-8 rounded-lg bg-slate-800 flex items-center justify-center flex-shrink-0" data-id="element-320">
                  <item.icon className="w-4 h-4 text-orange-500" data-id="element-321" />
                </div>
                <span className="text-slate-300 text-sm" data-id="element-322">{item.text}</span>
              </div>)}
          </div>
        </div>
      </div>

      <div className="mt-10" data-id="element-323">
        <PrimaryButton onClick={onNext} data-id="element-324">Start PTP Planning</PrimaryButton>
      </div>
    </div>;
}